(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function syncFooterLogosFromHeader() {
      const headerLogo = document.querySelector('.cplants-logo-block .header__heading-logo');
      if (!headerLogo || !headerLogo.getAttribute('src')) return;

      document.querySelectorAll('[data-cplants-logo-sync]').forEach(function (slot) {
        if (slot.querySelector('img')) return;

        const img = headerLogo.cloneNode(true);
        const width = slot.getAttribute('data-logo-width');

        img.classList.add('cplants-footer__logo');

        if (width) {
          img.style.maxWidth = width + 'px';
          img.style.width = 'auto';
          img.style.height = 'auto';
        }

        slot.appendChild(img);
      });
    }

    function initFooterAccordions() {
      const section =
        document.getElementById('shopify-section-{{ section.id }}') ||
        document.querySelector('.cplants-footer')?.closest('[id^="shopify-section-"]');

      if (!section) return;

      const accordions = Array.from(section.querySelectorAll('.cplants-footer__accordion'));
      if (!accordions.length) return;

      const desktopQuery = window.matchMedia('(min-width: 990px)');

      function isDesktop() {
        return desktopQuery.matches;
      }

      function setDesktopState() {
        accordions.forEach(function (accordion) {
          accordion.setAttribute('open', '');
        });
      }

      function setMobileState() {
        accordions.forEach(function (accordion) {
          accordion.removeAttribute('open');
        });
      }

      if (!section.dataset.footerAccordionBound) {
        section.dataset.footerAccordionBound = 'true';

        accordions.forEach(function (accordion) {
          const summary = accordion.querySelector('summary');
          if (!summary) return;

          summary.addEventListener('click', function (event) {
            if (isDesktop()) {
              event.preventDefault();
              return;
            }

            if (accordion.open) {
              return;
            }

            event.preventDefault();

            accordions.forEach(function (other) {
              if (other !== accordion) {
                other.removeAttribute('open');
              }
            });

            accordion.setAttribute('open', '');
          });
        });

        desktopQuery.addEventListener('change', function () {
          if (isDesktop()) {
            setDesktopState();
          } else {
            setMobileState();
          }
        });
      }

      if (isDesktop()) {
        setDesktopState();
      } else {
        setMobileState();
      }
    }

    function bootFooter() {
      syncFooterLogosFromHeader();
      initFooterAccordions();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootFooter);
    } else {
      bootFooter();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('.cplants-footer')) {
        bootFooter();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
